import React from 'react'
import PropTypes from 'prop-types'
import DateFnsUtils from '@date-io/date-fns'
import {
	MuiPickersUtilsProvider,
	TimePicker,
	KeyboardTimePicker,
} from '@material-ui/pickers'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import { createComponent } from 'react-fela'
import { omit } from 'timm'
import { bmsTheme, __wrapper, __errorMessage, __description } from './__style'

const Wrapper = createComponent(__wrapper, 'div')
const Error = createComponent(__errorMessage, 'div')
const Description = createComponent(__description, 'div')

export default class TimePickerMaterial extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedTime: props.initialValue || null,
		}
	}

	static getDerivedStateFromProps(props, state) {
		if (
			props.renderValueByProp &&
			Date.parse(new Date(props.initialValue)) !==
				Date.parse(new Date(state.selectedTime))
		) {
			return {
				selectedTime: props.initialValue || null,
			}
		}

		return null
	}

	handleTimeChange = (dummy, time) => {
		const { name } = this.props
		if (this.props.renderKeyboardTimePicker) {
			this.props.onTimeChange(dummy, name)
			this.setState({ selectedTime: dummy })
		} else {
			this.props.onTimeChange(time, name)
		}
	}

	render() {
		// omit these props to TimePicker as it does not recognize them
		const {
			renderKeyboardTimePicker,
			style,
			error,
			errorMessage,
			description,
		} = this.props

		const newProps = omit(this.props, [
			'onTimeChange',
			'name',
			'renderKeyboardTimePicker',
			'style',
			'description',
		])

		const { selectedTime } = this.state

		return (
			<Wrapper style={style}>
				<MuiThemeProvider theme={bmsTheme}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						{renderKeyboardTimePicker ? (
							<KeyboardTimePicker
								{...newProps}
								value={selectedTime}
								onChange={this.handleTimeChange}
								fullWidth
							/>
						) : (
							<TimePicker
								{...newProps}
								value={selectedTime}
								onChange={this.handleTimeChange}
								fullWidth
							/>
						)}
					</MuiPickersUtilsProvider>
				</MuiThemeProvider>
				{errorMessage && error && <Error>{errorMessage}</Error>}
				{description && <Description>{description}</Description>}
			</Wrapper>
		)
	}
}

TimePickerMaterial.propTypes = {
	/**
	 * If true, the TimePicker is disabled.
	 */
	disabled: PropTypes.bool,
	/**
	 * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	 * Since there is no particular event associated with the change the first argument will always be null
	 * and the second argument will be the new Date instance.
	 */
	onChange: PropTypes.func,
	/**
	 * Sets the time for the Time Picker programmatically.
	 */
	value: PropTypes.object,
	/**
	 * Pass the time to callback
	 */
	onTimeChange: PropTypes.func,
	/**
	 * name of the form component
	 */
	name: PropTypes.string,
	/**
	 * Render keyboard time picker material ui component
	 */
	renderKeyboardTimePicker: PropTypes.bool,
	/**
	 * Initial date to be displayed
	 */
	initialValue: PropTypes.string,
	/**
	 * show Error or not
	 */
	error: PropTypes.bool,
	/**
	 * Render value by prop
	 */
	renderValueByProp: PropTypes.bool,
}

TimePickerMaterial.defaultProps = {
	disabled: false,
	value: null,
	renderKeyboardTimePicker: false,
	initialValue: '',
	error: false,
	renderValueByProp: false,
}
